<template>
	<b-modal
		ref="tournament-tracking-modal"
		size="lg"
		:title="`LISTA DE TOPES`"
		hide-footer
		@hidden="handleCloseModal"
		scrollable
		style="z-index: 80000"
		no-close-on-backdrop
		no-close-on-esc
	>
		<template #modal-header>
			<div class="d-flex justify-content-between align-items-center w-100">
				<div class="font-weight-bold">Historial de torneos | {{ beneficiary.name }}</div>
				<div style="display: flex; gap: 0.5rem">
					<b-button variant="danger" @click="handleCloseModal" v-b-tooltip.hover="'Cerrar'">
						<FeatherIcon icon="XIcon" />
					</b-button>
				</div>
			</div>
		</template>
		<b-overlay :show="isLoading">
			<b-table-simple responsive sticky-header="60vh" no-border-collapse>
				<b-thead class="sticky-header" style="white-space: nowrap">
					<b-tr>
						<b-th v-for="field in fields" :key="field.key" :class="field.class">
							{{ field.label }}
							<v-icon
								v-if="field.key === 'local' || field.key === 'rival'"
								name="gi-boxing-glove"
								scale="1.3"
								class="ml-1"
								:class="field.key === 'local' ? 'text-danger' : 'text-primary'"
								style="transform: rotate(270deg)"
							/>
						</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<template v-if="rows.length > 0">
						<b-tr v-for="(row, index) in rows" :key="index">
							<b-td class="text-center">
								{{ row.tournament_name }}
							</b-td>
							<b-td class="text-center">
								{{ row.created_by_name }}
							</b-td>
							<b-td class="text-center">
								{{ row.created_at | myGlobalDayShort }}
							</b-td>
						</b-tr>
					</template>
					<b-tr v-if="rows.length === 0">
						<b-td :colspan="fields.length" class="text-center">No hay registros para mostrar</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-overlay>
	</b-modal>
</template>

<script>
import TournamentBeneficiariesService from "@/views/brain/tournament/views/beneficiaries/beneficiaries.service.js"
export default {
	name: "TournamentTrackingModal",
	props: {
		beneficiary: {
			type: Object,
			required: true,
		},
	},
	components: {},
	data: () => ({
		isLoading: false,
		fields: [
			{ key: "tournament", label: "TORNEO", class: "text-center" },
			{ key: "created_by", label: "ASIGNADO POR", class: "text-center" },
			{ key: "created_at", label: "FECHA", class: "text-center" },
		],
		rows: [],
	}),
	methods: {
		handleCloseModal() {
			this.$emit("close")
		},
		async getRows(page = 1) {
			try {
				this.isLoading = true
				const { data } = await TournamentBeneficiariesService.tracking(this.beneficiary.id)
				this.rows = data || []
			} catch (error) {
				console.error("Error fetching average weights report tracking:", error)
			} finally {
				this.isLoading = false
			}
		},
	},
	mounted() {
		this.$refs["tournament-tracking-modal"].toggle()
		this.getRows()
	},
}
</script>
